export const DIWALI_THEME_ENDS_AT = "2026-11-13T00:00:00+05:30";

export const DIWALI_SPARKLES = [
  { left: "24%", top: 8, size: 9, delay: 0.4, color: "#f59e0b" },
  { left: "29%", top: 32, size: 7, delay: 1.3, color: "#f97316" },
  { left: "34%", top: 6, size: 12, delay: 0, color: "#f59e0b" },
  { left: "39%", top: 30, size: 8, delay: 0.8, color: "#fbbf24" },
  { left: "44%", top: 12, size: 7, delay: 1.9, color: "#f97316" },
  { left: "48%", top: 8, size: 10, delay: 1.5, color: "#f59e0b" },
  { left: "53%", top: 32, size: 7, delay: 1.1, color: "#fbbf24" },
  { left: "57%", top: 14, size: 8, delay: 0.6, color: "#f59e0b" },
];

export const DIWALI_BANNER_LANTERNS = [
  { right: "14px", bottom: 2, width: 12, delay: 0 },
  { right: "32px", bottom: 0, width: 9, delay: 1.6 },
  { right: "48px", bottom: -2, width: 10, delay: 3.2 },
];

export const DIWALI_RANGOLI_PETALS = [0, 45, 90, 135, 180, 225, 270, 315];

/** True while the Diwali navbar theme should show. */
export const handleIsDiwaliTheme = ({ now = new Date() } = {}) =>
  now < new Date(DIWALI_THEME_ENDS_AT);
